import React from 'react'

import { themeConfig } from 'themes'

import { COMPONENT_EXTENDER } from 'extender'

const FORM_VERSION = themeConfig.CompanyApplicationForm_Version

const SingleContainerLayout = COMPONENT_EXTENDER('components/layouts/SingleContainerLayout')
const CompanyApplicationFormComponent = COMPONENT_EXTENDER(
    `components/core/ApplicationForms/CompanyApplicationForm/${FORM_VERSION}-CompanyApplicationForm-component`
)

const CompanyApplicationPage = () => (
    <SingleContainerLayout>
        <CompanyApplicationFormComponent />
    </SingleContainerLayout>
)

export default CompanyApplicationPage
